/* eslint-disable react/display-name */
import React, { FunctionComponent, HTMLAttributes, ReactText, useContext } from 'react'
import { Table } from 'antd'

import { SortOrder } from 'antd/lib/table/interface'
import { ColumnType } from 'antd/es/table'
import { SearchOutlined } from '@ant-design/icons'

import ListLayout from '../../layouts/ListLayout'
import { onTableChange } from '../../components/useTable'
import FilterTextSearch from '../../components/FilterTextSearch'
import FilterTags from '../../components/filterTags'
import { LocalizationContext } from '../../providers/LocalizationProvider'
import { Location } from '../../providers/ClientProvider/client/services/locations/types'

interface ColumnProps {
  currentSort: { [key: string]: SortOrder }
  handleFilter: (value: ReactText, dataIndex: string) => void
  locationsPage: any
  t: any
}

export const Columns = (props: ColumnProps): ColumnType<Location>[] => {
  return [
    {
      title: props.t(props.locationsPage.name),
      dataIndex: 'name',
      sorter: true,
      sortOrder: props?.currentSort['name'],
      filterIcon: <SearchOutlined />,
      filterDropdown: ({ setSelectedKeys, selectedKeys }): JSX.Element =>
        FilterTextSearch({
          setSelectedKeys: setSelectedKeys,
          selectedKeys: selectedKeys,
          handleFilter: props.handleFilter,
          dataIndex: 'name'
        })
    },
    {
      title: props.t(props.locationsPage.recordsAmount),
      sorter: true,
      responsive: ['md'],
      render: (value: any, record) => {
        return (record.geoData && record.geoData.length) || 0
      }
    }
  ]
}

interface LocationsViewProps {
  locations?: Location[]
  loading: boolean
  total: number
  currentPage: number
  currentSort: { [key: string]: SortOrder }
  onTableChange: onTableChange<Location>
  handleOnRowClick: (id: string) => void
  onCreateNewLocation: () => void
  handleFilter: (value: ReactText, dataIndex: string) => void
}

const LocationsView: FunctionComponent<LocationsViewProps> = (props: LocationsViewProps) => {
  const { t, dictionary } = useContext(LocalizationContext)
  const locationsPage = dictionary.locationsPage

  return (
    <ListLayout
      title={t(dictionary.layouts.locations)}
      buttonAction={props.onCreateNewLocation}
      buttonText={t(locationsPage.addLocation)}
    >
      <FilterTags />
      <Table
        rowClassName='list-layout__list-row'
        columns={Columns({
          currentSort: props.currentSort,
          handleFilter: props.handleFilter,
          t: t,
          locationsPage
        })}
        loading={props.loading}
        dataSource={props.locations}
        rowKey='_id'
        onChange={props.onTableChange}
        pagination={{
          total: props.total,
          current: props.currentPage,
          showTotal: (total, range): string =>
            `${range[0]}-${range[1]} ${t(dictionary.general.of)} ${total} ${t(
              dictionary.general.items
            )}`,
          showSizeChanger: false
        }}
        onRow={(record): HTMLAttributes<HTMLElement> => {
          return {
            onClick: (): void => props.handleOnRowClick(record._id)
          }
        }}
      />
    </ListLayout>
  )
}

export default LocationsView
